const KeenSlider = window.KeenSlider

const { breakpoints } = window.BAO.MediaBreakpoints
const { setInitialised, useArrows, addWheelControls } =
  window.BAO.Carousel.plugins

class ProductOOS extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 500,
        },
        mode: 'snap',
        slides: {
          perView: 2.2,
          spacing: 1,
        },
        breakpoints: {
          [`(min-width: ${breakpoints.sm}px)`]: {
            slides: {
              perView: 4,
              spacing: 1,
            },
          },
          [`(min-width: ${breakpoints.md}px)`]: {
            slides: {
              perView: 3,
              spacing: 1,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        addWheelControls('horizontal'),
      ],
    )
  }
}

if (!customElements.get('product-oos')) {
  customElements.define('product-oos', ProductOOS)
}
